import { render } from "./TimeRefresher.vue?vue&type=template&id=61b23ba8"
import script from "./TimeRefresher.vue?vue&type=script&lang=js"
export * from "./TimeRefresher.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__